<template>
  <div>
    <ca-page>
      <ca-loader v-if="showLoading"></ca-loader>

      <ca-form
        v-else
        :key="formKey"
        :on-submit="onSubmit">
        <worker-basic-data-form
          :basic-data="basicData"
          @refresh-form="refreshForm"></worker-basic-data-form>
        <worker-form-footer
          back-label="Cancelar"
          :on-back="goBack"></worker-form-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { initFormObject } from 'packages/common/utils/utils';
import WorkerFormFooter from './components/WorkerFormFooter';
import { hasWorkerDraft, setWorkerDraft, getWorkerDraft } from './workersService';
import WorkerBasicDataForm from './components/basic-data-form/WorkerBasicDataForm';
import { clickToGoWorkerJobInfoFormPage } from './workerTrackerService';

const DEFAULT_WORKER_DATA = initFormObject([
  'allocation',
  'jobDescription',
  'union',
  { esocialStatus: 'D' },
]);

export default {
  name: 'WorkerFormPage',
  components: {
    WorkerBasicDataForm,
    WorkerFormFooter,
  },
  props: {
    nextStep: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formKey: 0,
      basicData: {},
      stockings: [],
      unions: [],
      jobDescriptions: [],
      showLoading: true,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.showLoading = false;
      this.setBasicData();
    },
    setBasicData() {
      this.basicData = hasWorkerDraft() ? getWorkerDraft()?.basicInfo : { ...DEFAULT_WORKER_DATA };
      if (this.basicData.name) {
        this.$store.dispatch('breadcrumb/setBreadcrumbProps', { workerName: this.basicData.name });
      }
    },
    goBack() {
      this.$router.replace({ name: 'WorkerPage' });
    },
    onSubmit() {
      clickToGoWorkerJobInfoFormPage();
      setWorkerDraft({ basicInfo: this.basicData });
      return this.nextStep();
    },
    refreshForm() {
      this.formKey++;
    },
    async onRefreshForm() {
      await this.$nextTick();
      this.refreshForm();
    },
  },
};
</script>
